import { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';
import { instance } from '../utils/axios';
import { loginRoute } from '../utils/API_Routes';

import styled from 'styled-components';
import Logo from '../assets/logo.svg'
import 'react-toastify/dist/ReactToastify.css';
import { useDispatch, useSelector } from 'react-redux';
import { setAuth } from '../features/auth/authSlice';
import { setUser } from '../features/user/userSlice';
import FormLoading from '../components/loading/FormLoading';

const Login = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const [userr, setUserr] = useState({
        Email: "",
        Password: ""
    });
    const [isLoading, setIsLoading] = useState(false);
    const { user } = useSelector((state) => state.user)
    useEffect(() => {
        if (user) {
            navigate('/');
        }
    }, [navigate, user])
    const toastCreator = (msg, tost) => {
        const toastOptions = {
            position: 'bottom-right',
            autoClose: 8000,
            pauseOnHover: true,
            draggable: true,
            theme: 'dark'
        }
        tost(msg, toastOptions);
        return false;
    }

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (handleValidation()) {
            setIsLoading(true);
            const timer = setTimeout(() => {
                toastCreator('Server may take 30 seconds to respond', toast.info)
            }, 2500)
            try {
                const { data } = await instance.post(loginRoute, {
                    ...userr
                },
                    {
                        headers: { 'Content-Type': 'application/json' },
                        withCredentials: true
                    }
                );
                if (data.status === false) {
                    toastCreator(data.msg, toast.error);
                    clearTimeout(timer)
                }
                if (data.status === true) {
                    clearTimeout(timer)
                    dispatch(setUser(data))
                    dispatch(setAuth({ accessToken: data.accessToken }))
                    navigate('/');
                }
                setIsLoading(false)
            }
            catch (error) {
                console.log(error);
            }
        };
    }
    const handleChange = (e) => {
        setUserr((prevValue) => {
            return { ...prevValue, [e.target.name]: e.target.value }
        });
    }

    const handleValidation = () => {
        const { Password, Email } = userr;
        if (Email === "" || Password === "") {
            return toastCreator('Email and Password is required', toast.error)
        }
        return true;
    }

    return (
        <>
            <FormContainer>
                <div className="form_wrapper">
                    <div className="brand">
                        <img src={Logo} alt="logo" />
                        <h1>Snappy</h1>
                    </div>
                    <form onSubmit={handleSubmit}>
                        <input type="email" name="Email" onChange={handleChange} placeholder='Email' />
                        <input type="password" name="Password" onChange={handleChange} placeholder='Password' />
                        <button type="submit" disabled={isLoading}>
                            {isLoading ? <FormLoading /> : "Login"}
                        </button>
                        <span>don't have an account? <Link to='/register'>Register</Link></span>
                    </form>
                </div>
            </FormContainer>
            <ToastContainer />
        </>
    )
}

const FormContainer = styled.div`
    height:100vh;
    width:100vw ;
    background-color: rgb(19,18,36);
    display:flex ;
    justify-content:center ;
    align-items:center;
    .form_wrapper{
        display:flex;
        flex-direction:column;
        gap:2rem;
        border-radius:2rem;
        background-color:#00000076 ;
        padding:3rem 5rem ;
    }
    .brand{
        display:flex ;
        align-items:center;
        gap:1rem;
        justify-content:center;
        img{
            height:5rem;
        }
        h1{
            color:#ffffff;
            text-transform:uppercase ;
        }
    }
    form{
        display:flex;
        flex-direction:column;
        gap:2rem;
        input{
            background-color:transparent ;
            padding:1rem ;
            border:0.1rem solid #4e0eff;
            border-radius:0.4rem;
            color:white;
            width:100%;
            font-size:1rem;
            &:focus{
                border:0.1rem solid #997af0;
                outline:none;
            }
        }
        button{
            background-color:#997af0;
            color:white;
            height:48px ;
            display:flex ;
            align-items:center ;
            justify-content:center ;
            border:none;
            font-weight:bold;
            cursor:pointer;
            border-radius:0.4rem;
            font-size:1rem;
            text-transform:uppercase;
            position:relative ;
            transition:0.5s ease-in-out;
            &:hover{
            background-color:#4e0eff;
            }
        }
        span{
            color:white;
            text-transform:uppercase ;
            a{
                color:#4e0eff;
                text-decoration:none ;
                font-weight:bold ;
            }
        }
    }
`


export default Login;